import FeatureLock from "@/components/FeatureLock";
import Schedule from "@/components/Schedule";
import useOrganizationPlan from "@/hooks/useOrganizationPlan";
import { Content } from "@/types";
import { Appointment02Icon } from "@hugeicons/core-free-icons";
import { useFormikContext } from "formik";
import { Schedule as ScheduleType } from "@/types/branch";

const normalizeSchedule = (schedule: ScheduleType | null) => {
  if (!schedule) return null;

  const hasOpenDays = Object.values(schedule).some(
    (day: any) => day && day.closed === false
  );

  return hasOpenDays ? schedule : null;
};

const Availability = () => {
  const { values, setFieldValue } = useFormikContext<Content>();
  const { isFeatureAvailable } = useOrganizationPlan("content");

  if (isFeatureAvailable("scheduling")) {
    return (
      <Schedule
        title="Disponibles"
        schedule={values.schedule}
        onChange={(newSchedule) =>
          setFieldValue("schedule", normalizeSchedule(newSchedule))
        }
      />
    );
  }

  return (
    <FeatureLock
      icon={Appointment02Icon}
      title="Automatiza la disponibilidad de tus platos"
      description="Deja de activar y desactivar platos manualmente. Con el Plan Pro, puedes programar días y horarios específicos para que tu menú se actualice solo. ¡Actualiza ahora y optimiza tu operación!"
    />
  );
};

export default Availability;